var _circle, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgContact = function SvgContact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.866 56.523a1.8 1.8 0 0 0 .996-.294 9.658 9.658 0 0 0 1.114-.878l5.053-4.498h9.405c1.455 0 2.68-.258 3.676-.776a5.205 5.205 0 0 0 2.256-2.285c.518-.996.777-2.212.777-3.648v-11.22c0-1.436-.26-2.651-.777-3.648a5.123 5.123 0 0 0-2.256-2.27c-.996-.527-2.221-.791-3.676-.791H30.566c-1.455 0-2.68.264-3.676.79a5.206 5.206 0 0 0-2.27 2.271c-.509.997-.763 2.212-.763 3.648v11.22c0 1.436.254 2.652.762 3.648a5.29 5.29 0 0 0 2.27 2.285c.997.518 2.222.776 3.677.776h.704v3.81c0 .566.136 1.015.41 1.347.283.342.678.513 1.186.513Zm.6-2.681v-4.248c0-.4-.082-.684-.248-.85-.166-.166-.45-.249-.85-.249h-1.802c-1.484 0-2.583-.366-3.296-1.098-.703-.743-1.054-1.832-1.054-3.267V32.924c0-1.426.351-2.505 1.054-3.238.713-.742 1.812-1.113 3.296-1.113h18.868c1.474 0 2.568.371 3.28 1.113.714.733 1.07 1.812 1.07 3.238V44.13c0 1.435-.356 2.524-1.07 3.267-.712.732-1.806 1.098-3.28 1.098H39.94c-.41 0-.742.044-.996.132-.254.088-.517.273-.79.557l-4.688 4.658Z",
    fill: "#fff"
  })));
};

export default SvgContact;